import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'dataName' })

export class DataNamePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) { }

    transform(value: string) {

        if(value){
            const months = [
                'Janeiro', 'Fevereiro', 'Março', 'Abril',
                'Maio', 'Junho', 'Julho', 'Agosto',
                'Setembro', 'Outubro', 'Novembro', 'Dezembro'
            ];
    
            const [month, year] = value.split('/');
            const monthIndex = parseInt(month) - 1 

            return ` ${months[monthIndex]} 20${year}`
        } else {
            return value
        }


        
    }

}